import React from "react";

import {
    // Bar,
    // Bubble,
    // Line,
    // Pie,
    Doughnut,
    // Line,
    // PolarArea,
    // Radar,
    // Radar,
    // PolarArea,
    // Bubble,
} from "react-chartjs-2";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend,
    Filler,
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";
import { RootState } from "../../store";
import { connect } from "react-redux";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    RadialLinearScale,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartDataLabels,
);

export type ChartType =
    | "line"
    | "doughnut"
    | "pie"
    | "radar"
    | "polarArea"
    | "bubble";

export interface ChartItem {
    label: string;
    value: number;
    percentage?: number;

}

interface Props {
    data: ChartItem[];
    type?: ChartType;
    title?: string;
    onDependenciaBajasClick?: (opcion: string, anio?: number) => void;
    isDarkMode: boolean;
}


const BajasChart: React.FC<Props> = ({ data, type = "doughnut", title = "Inventario", onDependenciaBajasClick, isDarkMode }) => {
    const chartData = {
        labels: data.map((item) => item.label),
        datasets: [
            {
                label: title,
                data: data.map((item) => item.value),
                backgroundColor: [
                    "#c24a4a", // Azul suave
                    "#d47b7b", // Azul claro       
                ],
                borderColor: "#ffffff",
                borderWidth: 0.5,
                borderRadius: 3,
            },
        ],
    };

    const handleBarClick = (_event: any, elements: any[]) => {
        if (!elements || elements.length === 0) {
            return;
        }

        const index = elements[0].index;

        const dependenciaSeleccionada = data[index];
        if (!dependenciaSeleccionada) {
            return;
        }

        if (onDependenciaBajasClick) {
            onDependenciaBajasClick(
                dependenciaSeleccionada.label
            );
        }
    };

    // CONFIGURACIÓN GENERAL
    const options = {

        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: "bottom" as const,

                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",

                    font: {
                        size: 11,
                    },
                    color: isDarkMode ? "#ffffffa9" : "#30353ac4",
                    padding: 8,
                    boxWidth: 10,
                    boxHeight: 10,
                },

                fullSize: true,
            },
            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        const index = context.dataIndex;
                        const item = data[index];

                        if (!item) return "";

                        const porcentaje =
                            item.percentage !== undefined
                                ? ` (${item.percentage} %)`
                                : "";

                        return `${item.label}: ${item.value.toLocaleString(
                            "es-CL"
                        )}${porcentaje}`;
                    },
                },
            },
            datalabels: {
                display: function (context: any) {
                    const value =
                        context.dataset.data[context.dataIndex];
                    return value > 0;
                },
                color: "#ffffff",
                font: {
                    weight: "bold" as const,
                    size: 11,
                },
                formatter: function (
                    value: number,
                    context: any
                ) {
                    const total = context.dataset.data.reduce(
                        (a: number, b: number) => a + b,
                        0
                    );

                    const percentage =
                        total > 0
                            ? ((value / total) * 100).toFixed(1)
                            : "0";

                    if (
                        type === "doughnut" ||
                        type === "pie"
                    ) {
                        return `${value}\n${percentage}%`;
                    }

                    return value.toLocaleString("es-CL");
                },
                textAlign: "center" as const,
                anchor: "end" as const,
                align: "start" as const,
                backgroundColor: "rgba(241, 241, 241, 0.04)",
                borderRadius: 4,
                padding: {
                    top: 4,
                    bottom: 4,
                    left: 6,
                    right: 6,
                },
            },
        },
        onClick: handleBarClick,
    };


    return <Doughnut data={chartData} options={options} />;
    //Bubble PolarArea Radar Doughnut Line
};

const mapStateToProps = (state: RootState) => ({
    isDarkMode: state.darkModeReducer.isDarkMode,
});
export default connect(mapStateToProps, {
}
)(BajasChart);